module.exports = __webpack_public_path__ + "img/meeting-rules.5dc9dd26.svg";